<template>
    <van-popup class="common-pop" v-model:show="show" position="bottom" closeable close-on-popstate round :z-index="3001">
        <div class="pop-title">{{ $t(title) }}</div>
        <div class="common-content">
            <div v-if="$slots.title" class="title">
                <slot name="title"></slot>
            </div>
            <div class="content">
                <van-pull-refresh
                    v-model="refreshing"
                    :pulling-text="$t('Refresh_after_release')"
                    :loosing-text="$t('Refresh_after_release')"
                    :loading-text="$t('Loading_please_wait')"
                    @refresh="onRefresh"
                >
                    <template #loading> </template>
                    <slot v-if="!empty"></slot>
                    <Empty v-else />
                </van-pull-refresh>
            </div>
            <div v-if="$slots.foot" class="foot">
                <slot name="foot"></slot>
            </div>
        </div>
    </van-popup>
</template>
<script setup lang="ts">
import Empty from '@/components/empty.vue'
defineProps({
    title: {
        type: String,
        default: () => '',
    },
    empty: {
        type: Boolean,
        default: false,
    },
})
const emit = defineEmits(['refresh'])

const show = defineModel()
const refreshing = defineModel('refresh', { default: false })

const onRefresh = () => {
    emit('refresh')
}
</script>
<style scoped lang="scss">
.common-content {
    @apply flex flex-col;

    .content {
        flex: 1;
        overflow-y: auto;
    }
    .title {
        margin-bottom: 10px;
        display: flex;
        border-bottom: 2px solid rgba(120, 128, 148, 0.3);

        &:first-child {
            box-sizing: border-box;
        }
    }
}
</style>
